export const referral = {
  detail: {
    total: {
      linkCreated: 4,
      linkClick: 10,
      walletConnected: 5,
      transactionReferred: 4,
    },
    data: [
      {
        linkClick: 2,
        walletConnected: 2,
        transactionReferred: 1,
        address: "0x81495eBd37c266ccb6516E037d7f76ABf016624e",
      },
      {
        linkClick: 2,
        walletConnected: 1,
        transactionReferred: 1,
        address: "0x71cF60412a189cD777FF0bA50485299DfdD89ed3",
      },
      {
        linkClick: 2,
        walletConnected: 1,
        transactionReferred: 1,
        address: "0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266",
      },
      {
        linkClick: 4,
        walletConnected: 1,
        transactionReferred: 1,
        address: "0xC4956273f19774b9Fb871fFedA908BE4dD9b56EF",
      },
    ],
  },
  program: {
    _id: "66c81cd663ec1c03d09f09ba",
    campaignContentSets: [],
    objectives: [
      {
        _id: "66c81cd663ec1c03d09f09b7",
        entity: "66c8189a5fb810015d64d11e",
        created: "2024-08-23T05:23:34.080Z",
        updated: "2024-08-23T05:23:34.080Z",
        type: "tokenIn",
        chainId: 1,
        smartContractAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        __v: 0,
      },
    ],
    utms: [
      "66c81cd6592cb9a4e429e1f8",
      "66c81cd6592cb9a4e429e21d",
      "66c81cd6592cb9a4e429e241",
      "66c81cd6592cb9a4e429e262",
    ],
    entity: "66c8189a5fb810015d64d11e",
    name: "metacrmReferral",
    isReferral: true,
    referralUrl: "metacrm.inc",
    description: "This is referral program",
    startFrom: "2024-08-23T05:23:34.162Z",
    endAt: "2034-08-21T11:46:48.002Z",
    status: "scheduled",
    created: "2024-08-23T05:23:34.162Z",
    updated: "2024-08-23T05:23:34.162Z",
    __v: 4,
    referralCount: 4,
  },
};

export const x = {
  list: [
    {
      _id: "673634b72de8271123d0ae78",
      postLinks: [
        "x.com/metacrm_inc?test-id=817450293523910000",
        "x.com/metacrm_inc?test-id=577356159060781800",
        "x.com/metacrm_inc?test-id=849350048183286300",
      ],
      entity: "66c8189a5fb810015d64d11e",
      name: "Checking what's New recently - Dec. 2024",
      description: " X Space AMA",
      created: "2024-11-14T17:34:47.812Z",
      updated: "2024-11-28T10:19:32.228Z",
      __v: 0,
      shared: true,
      authors: [
        "https://pbs.twimg.com/profile_images/378800000857919980/lHqPIZza_normal.png",
        "https://pbs.twimg.com/profile_images/1810478548957933568/7VD3yNDK_normal.jpg",
        "https://pbs.twimg.com/profile_images/1609596934557429760/lIbH-TCC_normal.jpg",
      ],
    },
    {
      _id: "6736350bd58e65114740d2bc",
      postLinks: [
        "x.com/metacrm_inc?test-id=625806639465256000",
        "x.com/metacrm_inc?test-id=646881221997790600",
        "x.com/metacrm_inc?test-id=62922130203247660",
      ],
      entity: "66c8189a5fb810015d64d11e",
      name: "Airdrop is Coming",
      description: "Airdrop announcement",
      created: "2024-11-14T17:36:11.915Z",
      updated: "2024-11-14T17:36:11.915Z",
      __v: 0,
      authors: [
        "https://pbs.twimg.com/profile_images/1744289390736613378/alcfxov3_normal.jpg",
        "https://pbs.twimg.com/profile_images/1744289390736613378/alcfxov3_normal.jpg",
        "https://pbs.twimg.com/profile_images/1744289390736613378/alcfxov3_normal.jpg",
      ],
    },
    {
      _id: "6736350bd58e65114740d2bb",
      postLinks: [
        "x.com/metacrm_inc?test-id=522771736162418000",
        "x.com/metacrm_inc?test-id=808193714141413500",
        "x.com/metacrm_inc?test-id=983866893189770800",
      ],
      entity: "66c8189a5fb810015d64d11e",
      name: "Restaking is Live",
      description: "Restaking is Live",
      created: "2024-11-14T17:36:11.914Z",
      updated: "2024-11-14T17:36:11.914Z",
      __v: 0,
      authors: [
        "https://pbs.twimg.com/profile_images/1609596934557429760/lIbH-TCC_normal.jpg",
        "https://pbs.twimg.com/profile_images/1810478548957933568/7VD3yNDK_normal.jpg",
        "https://pbs.twimg.com/profile_images/378800000857919980/lHqPIZza_normal.png",
      ],
    },
    {
      _id: "67443f2aebd94411156e4ad0",
      postLinks: ["x.com/0xCheshire/status/1860915732022006143"],
      entity: "66c8189a5fb810015d64d11e",
      name: "TGE countdown",
      description: "6 Days remaining for presale",
      endDate: "2025-01-09T23:59:59.999Z",
      created: "2024-11-25T09:11:06.716Z",
      updated: "2024-11-25T09:11:06.716Z",
      __v: 0,
      authors: [
        "https://pbs.twimg.com/profile_images/1744289390736613378/alcfxov3_normal.jpg",
        "https://pbs.twimg.com/profile_images/1744289390736613378/alcfxov3_normal.jpg",
        "https://pbs.twimg.com/profile_images/1744289390736613378/alcfxov3_normal.jpg",
      ],
    },
  ],
  detail: {
    name: "Market report",
    description: "Top Defi projects in 2024",
    authors: [
      "https://pbs.twimg.com/profile_images/378800000857919980/lHqPIZza_normal.png",
      "https://pbs.twimg.com/profile_images/1810478548957933568/7VD3yNDK_normal.jpg",
      "https://pbs.twimg.com/profile_images/1609596934557429760/lIbH-TCC_normal.jpg",
    ],
    posts: [
      {
        impressions: 58018,
        likes: 5542,
        comments: 2880,
        reposts: 770,
        _id: "6736350cd58e65114740d2ce",
        bookmarks: 752,
        postLink: "x.com/metacrm_inc?test-id=983866893189770800",
        author: {
          _id: "673634b72de8271123d0ae82",
          username: "dogecoin",
          image:
            "https://pbs.twimg.com/profile_images/378800000857919980/lHqPIZza_normal.png",
          name: "Dogecoin",
        },
        postDate: "2024-11-12T06:11:36.868Z",
        __v: 0,
      },
      {
        impressions: 57920,
        likes: 5427,
        comments: 2904,
        reposts: 728,
        _id: "6736350bd58e65114740d2cb",
        bookmarks: 724,
        postLink: "x.com/metacrm_inc?test-id=808193714141413500",
        author: {
          _id: "673634b72de8271123d0ae84",
          username: "LegionMemeWorld",
          image:
            "https://pbs.twimg.com/profile_images/1810478548957933568/7VD3yNDK_normal.jpg",
          name: "Legion",
        },
        postDate: "2024-11-08T08:19:24.624Z",
        __v: 0,
      },
      {
        impressions: 58403,
        likes: 5236,
        comments: 2976,
        reposts: 780,
        _id: "6736350bd58e65114740d2c9",
        bookmarks: 722,
        postLink: "x.com/metacrm_inc?test-id=522771736162418000",
        author: {
          _id: "673634b72de8271123d0ae86",
          username: "CoinMarketCap",
          image:
            "https://pbs.twimg.com/profile_images/1609596934557429760/lIbH-TCC_normal.jpg",
          name: "CoinMarketCap",
        },
        postDate: "2024-11-05T17:34:07.883Z",
        __v: 0,
      },
    ],
  },
  feed: [
    {
      _id: "6736350cd58e65114740d2ce",
      impressions: 58018,
      likes: 5542,
      comments: 2880,
      reposts: 770,
      bookmarks: 752,
      postLink: "x.com/metacrm_inc?test-id=983866893189770800",
      author: {
        _id: "673634b72de8271123d0ae82",
        username: "dogecoin",
        id: "2235729541",
        image:
          "https://pbs.twimg.com/profile_images/378800000857919980/lHqPIZza_normal.png",
        name: "Dogecoin",
        created: "2024-11-14T17:34:47.922Z",
        __v: 0,
      },
      text: "Sample post text related to x.com/metacrm_inc?test-id=983866893189770800. Here's some content to make it interesting.",
      postDate: "2024-11-12T06:11:36.868Z",
      __v: 0,
      engagement: 9192,
    },
    {
      _id: "6736350bd58e65114740d2cb",
      impressions: 57920,
      likes: 5427,
      comments: 2904,
      reposts: 728,
      bookmarks: 724,
      postLink: "x.com/metacrm_inc?test-id=808193714141413500",
      author: {
        _id: "673634b72de8271123d0ae84",
        username: "LegionMemeWorld",
        id: "1808164869117710336",
        image:
          "https://pbs.twimg.com/profile_images/1810478548957933568/7VD3yNDK_normal.jpg",
        name: "Legion",
        created: "2024-11-14T17:34:47.926Z",
        __v: 0,
      },
      text: "Sample post text related to x.com/metacrm_inc?test-id=808193714141413500. Here's some content to make it interesting.",
      postDate: "2024-11-08T08:19:24.624Z",
      __v: 0,
      engagement: 9059,
    },
    {
      _id: "6736350bd58e65114740d2c9",
      impressions: 58403,
      likes: 5236,
      comments: 2976,
      reposts: 780,
      bookmarks: 722,
      postLink: "x.com/metacrm_inc?test-id=522771736162418000",
      author: {
        _id: "673634b72de8271123d0ae86",
        username: "CoinMarketCap",
        id: "2260491445",
        image:
          "https://pbs.twimg.com/profile_images/1609596934557429760/lIbH-TCC_normal.jpg",
        name: "CoinMarketCap",
        created: "2024-11-14T17:34:47.927Z",
        __v: 0,
      },
      text: "Sample post text related to x.com/metacrm_inc?test-id=522771736162418000. Here's some content to make it interesting.",
      postDate: "2024-11-05T17:34:07.883Z",
      __v: 0,
      engagement: 8992,
    },
  ],
  performance: {
    total: {
      impressions: {
        count: 77192,
        growth: "-",
      },
      likes: {
        count: 5390,
        growth: "-",
      },
      comments: {
        count: 2828,
        growth: "-",
      },
      reposts: {
        count: 760,
        growth: "-",
      },
      bookmarks: {
        count: 715,
        growth: "-",
      },
    },
    chartData: [
      {
        date: "2025-01-03",
        impressions: 51828,
        likes: 2539,
        comments: 1319,
        reposts: 372,
        bookmarks: 347,
      },
      {
        date: "2025-01-04",
        impressions: 56497,
        likes: 3039,
        comments: 1571,
        reposts: 443,
        bookmarks: 418,
      },
      {
        date: "2025-01-05",
        impressions: 61601,
        likes: 3587,
        comments: 1875,
        reposts: 526,
        bookmarks: 490,
      },
      {
        date: "2025-01-06",
        impressions: 66542,
        likes: 4110,
        comments: 2163,
        reposts: 595,
        bookmarks: 563,
      },
      {
        date: "2025-01-07",
        impressions: 70793,
        likes: 4616,
        comments: 2434,
        reposts: 656,
        bookmarks: 631,
      },
      {
        date: "2025-01-08",
        impressions: 75469,
        likes: 5168,
        comments: 2724,
        reposts: 734,
        bookmarks: 690,
      },
      {
        date: "2025-01-09",
        impressions: 77192,
        likes: 5390,
        comments: 2828,
        reposts: 760,
        bookmarks: 715,
      },
    ],
    diffData: [
      {
        date: "2025-01-03",
        impressions: 5094,
        likes: 479,
        comments: 306,
        reposts: 72,
        bookmarks: 67,
      },
      {
        date: "2025-01-04",
        impressions: 4669,
        likes: 500,
        comments: 252,
        reposts: 71,
        bookmarks: 71,
      },
      {
        date: "2025-01-05",
        impressions: 5104,
        likes: 548,
        comments: 304,
        reposts: 83,
        bookmarks: 72,
      },
      {
        date: "2025-01-06",
        impressions: 4941,
        likes: 523,
        comments: 288,
        reposts: 69,
        bookmarks: 73,
      },
      {
        date: "2025-01-07",
        impressions: 4251,
        likes: 506,
        comments: 271,
        reposts: 61,
        bookmarks: 68,
      },
      {
        date: "2025-01-08",
        impressions: 4676,
        likes: 552,
        comments: 290,
        reposts: 78,
        bookmarks: 59,
      },
      {
        date: "2025-01-09",
        impressions: 1723,
        likes: 222,
        comments: 104,
        reposts: 26,
        bookmarks: 25,
      },
    ],
  },
};

export const notification = {
  list: [
    {
      _id: "67c81c1e872461e868bf4077",
      targetAudiences: [
        {
          value: "OG Role",
          label: "OG Role",
        },
      ],
      isBroadcast: false,
      isSchedule: false,
      ctaButtonEnabled: false,
      isArchived: false,
      appendUTM: true,
      sendTime: "2025-03-28T08:18:35.882Z",
      channels: {
        widget: true,
        discord: true,
        telegram: true,
        email: true,
        xmtp: true,
      },

      title: "🚀 New Feature Alert: Notification Module is LIVE!",
      content: "Hello!~~",
      image: "",
      buttonText: "",
      buttonUrl: "",
      emailSetting: "67c54dc788fbfc389250ffdb",
      status: "sent",
      entity: "659e2421a68ca1205a0faafa",
      createdAt: "2025-03-05T09:40:46.242Z",
      updatedAt: "2025-03-05T09:40:52.030Z",
      __v: 0,
    },
    {
      _id: "67c669d56c2c81177bc04800",
      targetAudiences: [
        {
          label: "All",
          isAllOption: true,
          value: "",
        },
      ],
      isBroadcast: true,
      isSchedule: false,
      ctaButtonEnabled: true,
      isArchived: false,
      appendUTM: true,
      sendTime: "2025-08-28T08:18:35.882Z",
      channels: {
        widget: true,
        discord: true,
        telegram: true,
        email: true,
        xmtp: true,
      },
      title: "🚀 New Feature Alert: Notification Module is LIVE! NEW",
      content: "hiiiiiiii",
      image:
        "https://storage.googleapis.com/metacrm-upload-dev/campaign/0xea32650A40EE259834bcfC0062f0038D61832b57/small-95d1a071-5807-4132-ae79-138d67ce0b69-1741056444.jpeg",
      buttonText: "test",
      buttonUrl: "http://google.com",
      emailSetting: "67c54dc788fbfc389250ffdb",
      status: "scheduled",
      entity: "659e2421a68ca1205a0faafa",
      createdAt: "2025-03-04T02:47:49.295Z",
      updatedAt: "2025-03-04T02:47:54.308Z",
      __v: 0,
    },
    {
      _id: "67c669d56c2c81177bc04800",
      targetAudiences: [
        {
          label: "All",
          isAllOption: true,
          value: "",
        },
      ],
      isBroadcast: true,
      isSchedule: false,
      ctaButtonEnabled: true,
      isArchived: false,
      appendUTM: true,
      sendTime: "2025-03-04T02:47:49.258Z",
      channels: {
        widget: true,
        discord: false,
        telegram: false,
        email: false,
        xmtp: false,
      },
      title: "🚀 New Feature Alert: Notification Module is LIVE!",
      content: "hiiiiiiii",
      image:
        "https://storage.googleapis.com/metacrm-assets/token/1/0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE.png",
      buttonText: "test",
      buttonUrl: "http://google.com",
      emailSetting: "67c54dc788fbfc389250ffdb",
      status: "draft",
      entity: "659e2421a68ca1205a0faafa",
      createdAt: "2025-03-04T02:47:49.295Z",
      updatedAt: "2025-03-04T02:47:54.308Z",
      __v: 0,
    },
  ],
  reach: {
    discord: 826,
    telegram: 23,
    email: 1121,
    xmtp: 222,
  },
  detail: {
    _id: "67e65b5b5994f44af37629ab",
    targetAudiences: [
      {
        label: "All",
        isAllOption: true,
        value: "",
      },
    ],
    isBroadcast: true,
    isSchedule: false,
    ctaButtonEnabled: false,
    isArchived: false,
    appendUTM: true,
    sendTime: "2025-03-28T08:18:35.882Z",
    channels: {
      widget: true,
      discord: true,
      telegram: true,
      email: false,
      xmtp: false,
    },
    estimatedReachWhenSent: [
      {
        name: "email",
        number: 1,
      },
      {
        name: "telegram",
        number: 320,
      },
      {
        name: "discord",
        number: 438,
      },
      {
        name: "xmtp",
        number: 0,
      },
    ],
    title: "🚀 New Feature Alert: Notification Module is LIVE!",
    content:
      "Looking to boost engagement and keep your community in the loop?\nMetaCRM’s brand-new Notification Module is here to transform the way you communicate.\n\n✨ What’s inside?\n\n🎯 Tailored Messaging to connect more personally\n\n📡 Multi-Channel Delivery to reach users wherever they are\n\n🛠️ Fully Customizable to match your unique needs\n\nBecause your users don’t hate being notified — they hate missing out. Make every message count. Unleash the full power of communication with MetaCRM.\n\n🔥 Book a Demo Now 👉 https://tally.so/r/w5vGMP  ",
    image:
      "https://storage.googleapis.com/metadesk-prod/notification/66cfe40b6dcc6beaab8ba6e8/Marketing的複本-98f9a71b-bfd8-40a3-aa71-2f585859e04c-1743149861.png",
    buttonText: "",
    buttonUrl: "",
    emailSetting: {
      _id: "67e4f8f0b30cae30fba3ac35",
      entity: "64a7d2b725948474b7fc028e",
      __v: 0,
      companyAddress: "",
      createdAt: "2025-03-27T07:06:24.594Z",
      emailAddress: "",
      privacyPolicyLink: "",
      socialMediaLink: "",
      updatedAt: "2025-03-28T08:18:35.873Z",
      websiteURL: "",
    },
    status: "sent",
    entity: "64a7d2b725948474b7fc028e",
    createdAt: "2025-03-28T08:18:35.890Z",
    updatedAt: "2025-03-28T08:18:38.262Z",
    __v: 0,
  },
  overview: {
    overall: {
      sent: 308,
      opened: 104,
      clicked: 0,
      walletConnected: 0,
      objectAchieved: 0,
    },
    widget: {
      sent: 169,
      opened: 104,
      clicked: 0,
      walletConnected: 0,
      objectAchieved: 0,
    },
    discord: {
      sent: 87,
      opened: 0,
      clicked: 0,
      walletConnected: 0,
      objectAchieved: 0,
    },
    telegram: {
      sent: 38,
      opened: 0,
      clicked: 0,
      walletConnected: 0,
      objectAchieved: 0,
    },
    email: {
      sent: 14,
      opened: 0,
      clicked: 0,
      walletConnected: 0,
      objectAchieved: 0,
    },
    xmtp: {
      sent: 0,
      opened: 0,
      clicked: 0,
      walletConnected: 0,
      objectAchieved: 0,
    },
  },
  performanceTable: [
    {
      isBroadcast: true,
      notificationTitle: "🚀 New Feature Alert: Notification Module is LIVE!",
      sendTime: "2025-03-05T09:40:46.229Z",
      sent: 14,
      opened: 0,
      clicked: 0,
      walletConnected: 0,
      objectiveAchieved: 0,
      _id: "67e13914c68915d5c59bf7b8",
      channel: "email",
    },
    {
      isBroadcast: true,
      notificationTitle: "🚀 New Feature Alert: Notification Module is LIVE!",
      sendTime: "2025-03-05T09:40:46.229Z",
      sent: 87,
      opened: 0,
      clicked: 0,
      walletConnected: 0,
      objectiveAchieved: 0,
      _id: "67e13914c68915d5c59bf7b8",
      channel: "discord",
    },
    {
      isBroadcast: true,
      notificationTitle: "🚀 New Feature Alert: Notification Module is LIVE!",
      sendTime: "2025-03-05T09:40:46.229Z",
      sent: 38,
      opened: 0,
      clicked: 0,
      walletConnected: 0,
      objectiveAchieved: 0,
      _id: "67e13914c68915d5c59bf7b8",
      channel: "telegram",
    },
    {
      isBroadcast: true,
      notificationTitle: "🚀 New Feature Alert: Notification Module is LIVE!",
      sendTime: "2025-03-05T09:40:46.229Z",
      sent: 169,
      opened: 104,
      clicked: 0,
      walletConnected: 0,
      objectiveAchieved: 0,
      _id: "67e13715c68915d5c59be9f8",
      channel: "widget",
    },
  ],
};
